import Tabs from "devextreme-react/tabs";
import React, {useCallback, useEffect, useRef, useState} from "react";
import './EEToolForm.scss'
import {ApplicationState, EDIT_MODES} from "../tool/includes/applicationState";
import {EstimateProgressStepInfo} from "../types/EstimateProgressStepInfo";
import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {EEInfoControl} from "./EEInfoControl";
import {useAuth} from "../../../../contexts/auth";
import {CompanyTypes} from "../../../../types/enums";
import {useEEToolContext} from "../contexts/eeToolContext";
import EEToolControl from "./EEToolControl";
import EEPricingControl from "./EEPricingControl";
import LoadPanel from "devextreme-react/load-panel";
import {Popup, SpeedDialAction} from "devextreme-react";
import {EstimatePopupControl} from "./EstimatePopupControl";
import EEOptionalItemsControl from "./EEOptionalItemsControl";

export function EEToolForm() {
    const adapterContext = useEEToolAdapterContext();
    const context = useEEToolContext();
    const {user} = useAuth();

    useEffect(() => {
        if (user?.companyTypeId === CompanyTypes.DEALER) {
            context.setDealerId(user.companyId ?? 0);
        }
    }, [user?.companyId])

    useEffect(() => {
        if (context.isLoaded) {
            setEnableDrawing(true);
            adapterContext.setCurrentStep(2);
        }
    }, [context.isLoaded])

    const [enableDrawing, setEnableDrawing] = useState(false);

    const steps: EstimateProgressStepInfo[] = [
        {
            text: 'Info',
            disabled: false,
            step: 1
        },
        {
            text: 'Draw Countertops',
            disabled: !enableDrawing,
            step: 2
        },
        {
            text: 'Add Material & Edging',
            disabled: !enableDrawing,
            step: 3
        },
        {
            text: 'Add Radius & Bumps',
            disabled: !enableDrawing,
            step: 4
        },
        {
            text: 'Add Backsplash',
            disabled: !enableDrawing,
            step: 5
        },
        {
            text: 'Add Sinks & CookTop',
            disabled: !enableDrawing,
            step: 6
        },
        {
            text: 'Add Optional Item(s)',
            disabled: !enableDrawing,
            step: 7
        },
        {
            text: 'Review Pricing & Print',
            disabled: !enableDrawing,
            step: 8
        }
    ];

    const tabItems = steps.map((item) => {
        if (item.step === 1) {
            return { ...item, icon: 'info' };
        }
        if (item.step < adapterContext.currentStep) {
            return { ...item, icon: 'check' };
        }
        return { ...item, icon: '' };
    });

    return (
        <div className='estimate-page'>
            <Tabs
                className="order-progress ee-tool-progress"
                dataSource={tabItems}
                selectedIndex={adapterContext.currentStep - 1}
                onItemClick={async (e) => {
                    if (adapterContext.drawApp && e.itemData) {
                        await adapterContext.drawApp.changeApplicationMode(e.itemData.step as EDIT_MODES);
                    } else {
                        if (e.itemData) {
                            adapterContext.setCurrentStep(e.itemData.step);
                        }
                    }
                }}
            >
            </Tabs>
            {adapterContext.currentStep === 1 && <EEInfoControl onContinue={() => {
                setEnableDrawing(true);
                adapterContext.setCurrentStep(2);
            }}></EEInfoControl>}
            {adapterContext.currentStep === 7 && <EEOptionalItemsControl></EEOptionalItemsControl>}
            {adapterContext.currentStep === 8 && <EEPricingControl></EEPricingControl>}
            {enableDrawing && adapterContext.currentStep !== 1 && adapterContext.currentStep !== 7 && adapterContext.currentStep !== 8 &&
                <EEToolControl></EEToolControl>}
            <LoadPanel visible={context.isLoading}></LoadPanel>
        </div>
    )
}
